function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, FadeTransition, LoadingSpinner } from '@deephaven/components';
import { GridRange, GridUtils } from '@deephaven/grid';
import { CanceledPromiseError, copyToClipboard, PromiseUtils } from '@deephaven/utils';
import Log from '@deephaven/log';
import IrisGridUtils from "./IrisGridUtils.js";
import IrisGridBottomBar from "./IrisGridBottomBar.js";
import "./IrisGridCopyHandler.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('IrisGridCopyHandler');
function isCopyRangesOperation(copyOperation) {
  return copyOperation.ranges != null;
}
function isCopyHeaderOperation(copyOperation) {
  return copyOperation.columnIndex != null;
}
/**
 * Component for handling copying of data from the Iris Grid.
 * - Prompts if necessary (large amount of rows copied)
 * - Tries to async copy, falls back to showing a "Click to Copy" button if that fails
 */
class IrisGridCopyHandler extends Component {
  static getStatusMessageText(copyState, rowCount) {
    switch (copyState) {
      case IrisGridCopyHandler.COPY_STATES.CONFIRMATION_REQUIRED:
        return "Are you sure you want to copy ".concat(rowCount.toLocaleString(), " rows to your clipboard?");
      case IrisGridCopyHandler.COPY_STATES.CLICK_REQUIRED:
        return "Fetched ".concat(rowCount.toLocaleString(), " rows!");
      case IrisGridCopyHandler.COPY_STATES.FETCH_ERROR:
        return 'Unable to copy data.';
      case IrisGridCopyHandler.COPY_STATES.FETCH_RANGES_IN_PROGRESS:
        return "Fetching ".concat(rowCount.toLocaleString(), " rows for clipboard...");
      case IrisGridCopyHandler.COPY_STATES.FETCH_HEADER_IN_PROGRESS:
        return 'Fetching header for clipboard...';
      case IrisGridCopyHandler.COPY_STATES.DONE:
        return 'Copied to Clipboard!';
      default:
        return '';
    }
  }
  static getCopyButtonText(buttonState) {
    switch (buttonState) {
      case IrisGridCopyHandler.BUTTON_STATES.FETCH_IN_PROGRESS:
        return 'Fetching';
      case IrisGridCopyHandler.BUTTON_STATES.CLICK_TO_COPY:
        return 'Click to Copy';
      case IrisGridCopyHandler.BUTTON_STATES.RETRY:
        return 'Retry';
      default:
        return 'Copy';
    }
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "textData", void 0);
    _defineProperty(this, "hideTimer", void 0);
    _defineProperty(this, "fetchPromise", void 0);
    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleCopyClick = this.handleCopyClick.bind(this);
    this.handleHideTimeout = this.handleHideTimeout.bind(this);
    this.state = {
      error: undefined,
      copyState: IrisGridCopyHandler.COPY_STATES.IDLE,
      buttonState: IrisGridCopyHandler.BUTTON_STATES.COPY,
      isShown: false,
      rowCount: 0
    };
  }
  componentDidMount() {
    var copyOperation = this.props.copyOperation;
    if (copyOperation != null) {
      this.startCopy();
    }
  }
  componentDidUpdate(prevProps) {
    var copyOperation = this.props.copyOperation;
    if (prevProps.copyOperation !== copyOperation) {
      this.startCopy();
    }
  }
  componentWillUnmount() {
    this.stopCopy();
  }
  startCopy() {
    log.debug2('startCopy');
    this.stopCopy();
    var copyOperation = this.props.copyOperation;
    if (copyOperation == null) {
      log.debug2('No copy operation set, cancelling out');
      this.setState({
        isShown: false
      });
      return;
    }
    var error = copyOperation.error;
    if (error != null) {
      log.debug('Showing copy error', error);
      this.setState({
        isShown: true,
        copyState: IrisGridCopyHandler.COPY_STATES.DONE,
        error
      });
      this.startHideTimer();
      return;
    }
    this.setState({
      isShown: true,
      error: undefined
    });
    if (isCopyRangesOperation(copyOperation)) {
      var ranges = copyOperation.ranges;
      var rowCount = GridRange.rowCount(ranges);
      this.setState({
        rowCount
      });
      if (rowCount > IrisGridCopyHandler.NO_PROMPT_THRESHOLD) {
        this.setState({
          buttonState: IrisGridCopyHandler.BUTTON_STATES.COPY,
          copyState: IrisGridCopyHandler.COPY_STATES.CONFIRMATION_REQUIRED
        });
        return;
      }
    }
    this.startFetch();
  }
  stopCopy() {
    this.textData = undefined;
    this.stopFetch();
    this.stopHideTimer();
  }
  handleBackgroundClick() {
    log.debug2('handleBackgroundClick');
    var copyState = this.state.copyState;
    if (copyState === IrisGridCopyHandler.COPY_STATES.DONE) {
      this.setState({
        isShown: false
      });
    }
  }
  handleCancelClick() {
    log.debug2('handleCancelClick');
    this.stopFetch();
    this.setState({
      isShown: false
    });
  }
  handleCopyClick() {
    var _this = this;
    return _asyncToGenerator(function* () {
      log.debug2('handleCopyClick');
      if (_this.textData != null) {
        try {
          yield _this.copyText(_this.textData);
          _this.showCopyDone();
        } catch (e) {
          log.error('Error copying text', e);
          _this.setState({
            error: 'Unable to copy. Verify your browser permissions.'
          });
        }
      } else {
        _this.startFetch();
      }
    })();
  }
  handleHideTimeout() {
    log.debug2('handleHideTimeout');
    this.stopHideTimer();
    this.setState({
      isShown: false
    });
  }
  copyText(text) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      log.debug2('copyText', text);
      _this2.textData = text;
      yield copyToClipboard(text);
    })();
  }
  showCopyDone() {
    this.setState({
      copyState: IrisGridCopyHandler.COPY_STATES.DONE
    });
    this.startHideTimer();
  }
  startFetch() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      _this3.stopFetch();
      var _this3$props = _this3.props,
        model = _this3$props.model,
        copyOperation = _this3$props.copyOperation;
      if (isCopyHeaderOperation(copyOperation)) {
        var columnIndex = copyOperation.columnIndex,
          columnDepth = copyOperation.columnDepth,
          movedColumns = copyOperation.movedColumns;
        log.debug('startFetch copyHeader', columnIndex, columnDepth);
        _this3.setState({
          buttonState: IrisGridCopyHandler.BUTTON_STATES.FETCH_IN_PROGRESS,
          copyState: IrisGridCopyHandler.COPY_STATES.FETCH_HEADER_IN_PROGRESS
        });
        var modelIndex = GridUtils.getModelIndex(columnIndex, movedColumns);
        var copyText = model.textForColumnHeader(modelIndex, columnDepth);
        if (copyText === undefined) {
          _this3.fetchPromise = undefined;
          _this3.setState({
            error: 'Invalid column header selected.',
            copyState: IrisGridCopyHandler.COPY_STATES.DONE
          });
          return;
        }
        _this3.fetchPromise = PromiseUtils.makeCancelable(copyText);
      } else {
        var ranges = copyOperation.ranges,
          includeHeaders = copyOperation.includeHeaders,
          userColumnWidths = copyOperation.userColumnWidths,
          _movedColumns = copyOperation.movedColumns,
          formatValues = copyOperation.formatValues;
        log.debug('startFetch copyRanges', ranges);
        _this3.setState({
          buttonState: IrisGridCopyHandler.BUTTON_STATES.FETCH_IN_PROGRESS,
          copyState: IrisGridCopyHandler.COPY_STATES.FETCH_RANGES_IN_PROGRESS
        });
        var hiddenColumns = IrisGridUtils.getHiddenColumns(userColumnWidths);
        var modelRanges = GridUtils.getModelRanges(ranges, _movedColumns);
        if (hiddenColumns.length > 0) {
          var subtractRanges = hiddenColumns.map(GridRange.makeColumn);
          modelRanges = GridRange.subtractRangesFromRanges(modelRanges, subtractRanges);
        }

        // Remove the hidden columns from the snapshot
        var formatValue = formatValues != null && formatValues ? (value, column) => model.displayString(value, column.type, column.name) : value => "".concat(value);
        _this3.fetchPromise = PromiseUtils.makeCancelable(model.textSnapshot(modelRanges, includeHeaders, formatValue));
      }
      try {
        var text = yield _this3.fetchPromise;
        _this3.fetchPromise = undefined;
        try {
          yield _this3.copyText(text);
          _this3.showCopyDone();
        } catch (e) {
          log.error('Error copying text', e);
          _this3.setState({
            buttonState: IrisGridCopyHandler.BUTTON_STATES.CLICK_TO_COPY,
            copyState: IrisGridCopyHandler.COPY_STATES.CLICK_REQUIRED
          });
        }
      } catch (e) {
        if (e instanceof CanceledPromiseError) {
          log.debug('User cancelled copy.');
        } else {
          log.error('Error fetching contents', e);
          _this3.fetchPromise = undefined;
          _this3.setState({
            buttonState: IrisGridCopyHandler.BUTTON_STATES.RETRY,
            copyState: IrisGridCopyHandler.COPY_STATES.FETCH_ERROR
          });
        }
      }
    })();
  }
  stopFetch() {
    if (this.fetchPromise) {
      log.debug2('stopFetch');
      this.fetchPromise.cancel();
      this.fetchPromise = undefined;
    }
  }
  startHideTimer() {
    this.stopHideTimer();
    this.hideTimer = setTimeout(this.handleHideTimeout, IrisGridCopyHandler.HIDE_TIMEOUT);
  }
  stopHideTimer() {
    if (this.hideTimer != null) {
      clearTimeout(this.hideTimer);
      this.hideTimer = undefined;
    }
  }
  render() {
    var _this$props = this.props,
      onEntering = _this$props.onEntering,
      onEntered = _this$props.onEntered,
      onExiting = _this$props.onExiting,
      onExited = _this$props.onExited;
    var _this$state = this.state,
      buttonState = _this$state.buttonState,
      copyState = _this$state.copyState,
      isShown = _this$state.isShown,
      rowCount = _this$state.rowCount,
      error = _this$state.error;
    var animation = copyState === IrisGridCopyHandler.COPY_STATES.DONE ? 'fade' : 'copy-slide-up';
    var copyButtonText = IrisGridCopyHandler.getCopyButtonText(buttonState);
    var statusMessageText = error !== null && error !== void 0 ? error : IrisGridCopyHandler.getStatusMessageText(copyState, rowCount);
    var isButtonContainerVisible = copyState !== IrisGridCopyHandler.COPY_STATES.DONE;
    var isFetching = buttonState === IrisGridCopyHandler.BUTTON_STATES.FETCH_IN_PROGRESS;
    var isDone = copyState === IrisGridCopyHandler.COPY_STATES.DONE;
    return /*#__PURE__*/_jsxs(IrisGridBottomBar, {
      animation: animation,
      isShown: isShown,
      className: classNames('iris-grid-copy-handler', {
        'copy-done': isDone
      }),
      onClick: this.handleBackgroundClick,
      onEntering: onEntering,
      onEntered: onEntered,
      onExiting: onExiting,
      onExited: onExited,
      children: [/*#__PURE__*/_jsx("div", {
        className: "status-message",
        children: /*#__PURE__*/_jsx("span", {
          children: statusMessageText
        })
      }), /*#__PURE__*/_jsx(FadeTransition, {
        in: isButtonContainerVisible,
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/_jsxs("div", {
          className: "buttons-container",
          children: [/*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn btn-outline-secondary btn-cancel",
            onClick: this.handleCancelClick,
            children: "Cancel"
          }), /*#__PURE__*/_jsxs(Button, {
            kind: isFetching ? 'tertiary' : 'primary',
            className: classNames('btn-copy', {
              'btn-spinner': isFetching
            }),
            onClick: this.handleCopyClick,
            disabled: isFetching,
            children: [isFetching && /*#__PURE__*/_jsx(LoadingSpinner, {
              className: "loading-spinner-vertical-align"
            }), copyButtonText]
          })]
        })
      })]
    });
  }
}
_defineProperty(IrisGridCopyHandler, "NO_PROMPT_THRESHOLD", 10000);
_defineProperty(IrisGridCopyHandler, "HIDE_TIMEOUT", 3000);
/**
 * Different states for the current copy operation
 */
_defineProperty(IrisGridCopyHandler, "COPY_STATES", {
  // No copy operation in progress
  IDLE: 'IDLE',
  // Large copy operation, confirmation required
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
  // Fetch is currently in progress for copy ranges operation
  FETCH_RANGES_IN_PROGRESS: 'FETCH_RANGES_IN_PROGRESS',
  // Fetch is currently in progress for copy header operation
  FETCH_HEADER_IN_PROGRESS: 'FETCH_HEADER_IN_PROGRESS',
  // There was an error fetching the data
  FETCH_ERROR: 'FETCH_ERROR',
  // Click is required to copy
  CLICK_REQUIRED: 'CLICK_REQUIRED',
  // The copy operation is completed and successfully copied to the clipboard
  DONE: 'DONE'
});
_defineProperty(IrisGridCopyHandler, "BUTTON_STATES", {
  COPY: 'COPY',
  FETCH_IN_PROGRESS: 'FETCH_IN_PROGRESS',
  CLICK_TO_COPY: 'CLICK_TO_COPY',
  RETRY: 'RETRY'
});
_defineProperty(IrisGridCopyHandler, "defaultProps", {
  copyOperation: null,
  onEntering: () => undefined,
  onEntered: () => undefined,
  onExiting: () => undefined,
  onExited: () => undefined
});
export default IrisGridCopyHandler;
//# sourceMappingURL=IrisGridCopyHandler.js.map